<template>
	<div style="border: 1px solid #ccc;padding:15px;background-color: #f5f5f5;">
		<div style="padding: 15px;background-color: #fff;" class="boxnumber">
			<div style="display: flex;">
				<label style="margin-right: 10px;line-height:40px;">副标题：</label>
				<el-input placeholder="请输入副标题" style="width:90%;" v-model="newsdata.description"></el-input>
			</div>
			<div style="display: flex;">
				<label style="margin-right: 10px;line-height:40px;">合作伙伴：</label>
				<el-input placeholder="请输入合作伙伴" style="width:90%;" v-model="newsdata.num1"></el-input>
			</div>
			<div style="display: flex;">
				<label style="margin-right: 10px;line-height:40px;">国家：</label>
				<el-input placeholder="请输入国家" style="width:90%;" v-model="newsdata.num2"></el-input>
			</div>
			<div style="display: flex;">
				<label style="margin-right: 10px;line-height:40px;">生产基地：</label>
				<el-input placeholder="请输入生产基地" style="width:90%;" v-model="newsdata.num3"></el-input>
			</div>
			<div style="display: flex;">
				<label style="margin-right: 10px;line-height:40px;">全球配送中心：</label>
				<el-input placeholder="请输入全球配送中心" style="width:90%;" v-model="newsdata.num4"></el-input>
			</div>
			<div style="display: flex;justify-content: center;">
				<el-button type="primary" style="margin: 15px 0;" @click="updatanews">编辑</el-button>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue'
	export default Vue.extend({
		data() {
			return {
				newsdata: {
					
				}
			}
		},
		methods: {
			updatanews() {
				//  编辑新闻
				console.log(this.newsdata);
				if (this.newsdata.description == "" || this.newsdata.num1 == '' || this.newsdata.num2 == '' || this.newsdata.num3 == '' || this.newsdata.num4 == '') {
					this.$message({
						showClose: true,
						message: '请填写全部内容',
						type: 'error'
					});
				} else {
					let that = this
					this.$confirm('确定要编辑吗', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then((res1) => {
						console.log(res1);
						if(res1 == 'confirm'){
							console.log('确认');
							that.newsdata.updatatime = that.$gettime()
							that.$post("/index/updatakrononum",that.newsdata).then(res=>{
								if(res.data=='编辑成功'){
									that.$message({
										type: 'success',
										message: '编辑成功!'
									});
								}else{
									that.$message({
										type: 'error',
										message: '编辑失败!'
									});
								}
							})
						}else{
							console.log('取消');
							this.$message({
								type: 'info',
								message: '已取消'
							});
						}
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
				}
			}
		},
		mounted() {
			this.$get('/index/getkrononum').then(res=>{
				this.newsdata = res.data[0]
			})
		},
		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
		}
	})
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #a5a5a5;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	.boxnumber div{
		margin: 10px auto;
		
	}
	.boxnumber div label{
		width:120px;
	}
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>